import React from 'react';
import { heroStats } from '../data/mockData';
import { ShieldCheck, Zap, TrendingUp, ArrowRight } from 'lucide-react';
import NeuralAI from './NeuralAI';

const iconMap = {
  ShieldCheck: ShieldCheck,
  Zap: Zap,
  TrendingUp: TrendingUp,
};

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-blue-50/60 via-white to-blue-50/30">
      {/* Subtle background circles */}
      <div className="absolute top-20 right-20 w-[500px] h-[500px] rounded-full bg-blue-100/30 blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-28 pb-20 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <div className="space-y-8">
            {/* Heading */}
            <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold leading-[1.1] tracking-tight text-gray-900">
              Váltsd eladássá a keresést egy{' '}
              <span className="text-blue-600">AI-al</span>, amely valóban érti a
              vásárlót.
            </h1>

            {/* Subtitle */}
            <p className="text-lg text-gray-500 leading-relaxed max-w-lg">
              AI-alapú ajánlómotor, amely hibrid kereséssel és LLM rangsorolással
              pontosan azt adja a vevőidnek, amit keresnek.
            </p>

            {/* CTA */}
            <a href="#widget-demo" className="inline-flex items-center gap-3 px-8 py-4 bg-blue-600 text-white text-base font-semibold rounded-full hover:bg-blue-700 transition-all duration-200 hover:shadow-lg hover:shadow-blue-600/25 group">
              Widget Demó indítása
              <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
            </a>

            {/* Stats row */}
            <div className="flex flex-wrap items-center gap-6 pt-4">
              {heroStats.map((stat) => {
                const Icon = iconMap[stat.icon];
                return (
                  <div key={stat.label} className="flex items-center gap-2 text-sm text-gray-500">
                    <Icon className="w-4 h-4 text-gray-400" />
                    <span>{stat.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right side - AI Neural Visual */}
          <div className="flex items-center justify-center">
            <div className="w-[270px] h-[270px] sm:w-[340px] sm:h-[340px] lg:w-[520px] lg:h-[520px]">
              <NeuralAI />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
